import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxBuildingsAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.5 15.52v-1.598h5V12.32h-5V10.72h5V9.12h-5V7.52h5V5.922h-5V4.32h5V1.922H2v19.2h2.5v-2.403h1.668v2.402H9.5V15.52ZM13.668 11.52V9.918h4.164V8.32h-4.164V6.72h4.164V4.32h-6.664v16.801h2.5v-8h4.164V11.52Zm0 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22 17.121h-2.5V14.72h-1.668v2.402h-2.5v1.598h2.5v2.402H19.5V18.72H22Zm0 0"
	})]
});
export default SvgBxBuildingsAlt;
